<template>
  <div class="etr">
    <!-- {{ search }} -->
    <!-- <br /><br />
    {{ item }}<br /><br /> -->
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="center" no-gutters>
          <b-col cols="8">
            <b-button-group>
              <b-button
                v-print="'#paper'"
                squared
                size="sm"
                class="mr-4"
                title="Print"
              >
                <i class="fa fa-print pr-3"></i>Print
              </b-button>
              <div class="inline-block" align-v="center">
                <i class="fa fa-handshake-o fa-2x mr-1 text-primary"></i>

                <span class="h4 ml-1">{{ item.to }}</span>
              </div>
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
              Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
          <div id="paper" class="mb-3 p-5 background-white text-secondary componentview">
            <div>
              <b-row class="header text-muted mb-4" no-gutters>
                <b-col cols="1">
                  <!-- <img
                    class="logo mt-4 ml-5 h-50px"
                    src="/img/brand/ABTA.jpg"
                    alt="ABTA"
                /> -->
                </b-col>
                <b-col class="text-center"
                  ><img
                    class="logo mb-3"
                    src="/img/brand/RGB Travel Places Primary Logo.bmp"
                    alt="Travel Places"
                    height="70"
                    width="190"
                  /><br />
                  <span>
                    Podium House 61 Chapel Road, Worthing, West Sussex, BN11
                    1HR<br />
                    Tel Accounts: +44 (0) 1903 832 899 Tel Sales: +44 (0) 1903
                    832888 Fax: +44 (0) 1903 231743</span
                  >
                </b-col>
                <b-col cols="1" class="mt-4 mr-5 text-right">
                  <img
                    class="logo h-30px"
                    src="/img/brand/IATA.jpg"
                    alt="IATA"
                  />
                </b-col>
              </b-row>
              <b-row class="border-bottom" no-gutters>
                <b-col class="text-center large uppercase strong">
                  Statement of Account
                </b-col>
              </b-row>
              <div class="large">
                <b-row class="my-4">
                  <b-col class="strong">
                    {{ item.to }} <br />
                    <div v-html="$helpers.breaklines(item.address)"></div>
                  </b-col>
                  <b-col class="text-right">
                    <b-row>
                      <b-col><span> Statement Date: </span></b-col>
                      <b-col>{{
                        (item.datestatement * 0.001) | moment("DD-MMM-YY")
                      }}</b-col>
                    </b-row>
                    <b-row class="my-3">
                      <b-col>Account:</b-col> <b-col>{{ item.slac }}</b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <div>
                  <table class="invoicetable" v-if="item.document">
                    <thead>
                      <tr>
                        <th
                          v-for="(field, findex) in item.document.fields"
                          :key="findex"
                          class="border-right-secondary"
                          :colspan="field.colspan"
                        >
                          <span v-html="$helpers.breaklines(field.label)" />
                        </th>
                      </tr>
                    </thead>
                    <!--     <tbody>
                      <tr class="spacer">
                        <td
                          class="text-center border-right-secondary pt-2"
                        ></td>
                        <td class="text-left border-right-secondary"></td>
                        <td class="text-center border-right-secondary"></td>
                        <td class="text-right border-right-secondary"></td>
                        <td class="text-right"></td>
                      </tr>

                      <tr v-for="(lineitem, index) in item.items" :key="index">
                        <td
                          class="text-center border-right-secondary pt-2 v-align-top"
                        >
                          <span>{{
                            (lineitem.dateref * 0.001) | moment("DD-MMM-YY")
                          }}</span>
                        </td>
                        <td
                          class="text-center border-right-secondary v-align-top"
                        >
                          <span>
                            {{
                              (lineitem.datetravel * 0.001)
                                | moment("DD-MMM-YY")
                            }}</span
                          >
                        </td>
                        <td
                          class="text-center border-right-secondary v-align-top"
                        >
                          {{ lineitem.ref }}
                        </td>
                        <td
                          class="text-center border-right-secondary v-align-top"
                        >
                          {{ lineitem.yourref }}
                        </td>
                        <td class="text-right v-align-top">
                          <b-row no-gutters>
                            <b-col class="text-right">
                              <span>
                                {{ lineitem.outstanding | currency("") }}</span
                              ></b-col
                            >
                            <b-col cols="2"
                              ><span v-if="lineitem.credit">CR</span>
                              <span v-else></span
                            ></b-col>
                          </b-row>
                        </td>
                      </tr>
                      <tr class="spacer">
                        <td
                          class="text-center border-right-secondary pt-2"
                        ></td>
                        <td class="text-left border-right-secondary"></td>
                        <td class="text-center border-right-secondary"></td>
                        <td class="text-right border-right-secondary"></td>

                        <td class="text-right"></td>
                      </tr>
                    </tbody> -->
                    <tbody>
                      <!-- SPACER -->
                      <tr class="spacer">
                        <template v-for="(col, cindex) in item.document.fields">
                          <td
                            v-if="cindex == item.document.fields.length - 1"
                            :key="'hspace' + cindex"
                            :class="'v-align-top'"
                          ></td>
                          <td
                            v-if="cindex == item.document.fields.length - 1"
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                          <td
                            v-if="cindex != item.document.fields.length - 1"
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                        </template>
                      </tr>
                      <!-- DATA -->
                      <tr
                        v-for="(row, rindex) in item.document.items"
                        :key="rindex"
                      >
                        <template v-for="(col, cindex) in row">
                          <td
                            v-if="cindex == row.length - 1"
                            :key="row + '_' + cindex"
                            :class="
                              item.document.fields[cindex].class +
                              ' v-align-top'
                            "
                          >
                            <span v-html="$helpers.breaklines(col.slice(1))" />
                          </td>
                          <td
                            v-if="cindex == row.length - 1"
                            :key="row + '_' + cindex"
                            :class="
                              item.document.fields[cindex].class +
                              ' border-right-secondary v-align-top'
                            "
                          >
                            <div v-if="parseFloat(col) < 0">CR</div>
                            <div v-else></div>
                          </td>

                          <td
                            v-if="cindex != row.length - 1"
                            :key="row + '_' + cindex"
                            :class="
                              item.document.fields[cindex].class +
                              ' border-right-secondary v-align-top'
                            "
                          >
                            <span v-html="$helpers.breaklines(col)" />
                          </td>
                        </template>
                      </tr>
                      <!-- SPACER -->
                      <tr class="spacer">
                        <template v-for="(col, cindex) in item.document.fields">
                          <td
                            v-if="cindex == item.document.fields.length - 1"
                            :key="'fspace' + cindex"
                            :class="'v-align-top'"
                          ></td>
                          <td
                            v-if="cindex == item.document.fields.length - 1"
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                          <td
                            v-if="cindex != item.document.fields.length - 1"
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                        </template>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="strong border-top-secondary">
                        <td></td>
                        <td colspan="3">Outstanding Balance GBP</td>

                        <td class="text-right border-left-secondary">
                          {{ Math.abs(item.outstanding) | currency("") }}
                        </td>
                        <td class="text-right">
                          <div v-if="parseFloat(item.outstanding) < 0">CR</div>
                          <div v-else></div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <b-row class="text-center small my-4">
                <b-col
                  >Note: This statement is in &pound; Sterling currency <br />
                  Payment: GBP, Bank: Lloyds Bank PLC, Sort Code: 30-00-02, A/c:
                  02056572, Swift: LOYD GB 2LCTY, IBAN: GB85 LOYD 300002
                  02056572<br />
                  VAT Reg No: GB 413 6406 79, Company Reg No: 08774160<br />
                  Travel Places, in association with American Express Global
                  Business Travel
                </b-col>
              </b-row>
            </div>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "SLStatementView",
  data() {
    return {
      busy: false,
      item: {
        items: [],
      },
      slac: null,
    };
  },
  computed: {
    isinvoice() {
      if (this.item) {
        return !this.item.credit;
      }
      return false;
    },
  },
  methods: {
    async load() {

      this.busy = true;
      let variables = {
        id: this.idselected,
      };

      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query statements(
              $id: String
            ) {
              statements(
                id: $id
              ) {
                id
                datestatement
                slac
                to
                address
                outstanding
                document {
                  fields {
                    key
                    label
                    class
                    colspan
                  }
                  items
                }
              }
            }
          `,
          variables,
        });

        this.item = response.data.statements[0];
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {

      this.busy = true;
      let variables = {
        id: this.idselected,
        documentformat: "STM_1",
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query statements(
              $id: String
              $documentformat: String
            ) {
              statements(
                id: $id
                documentformat: $documentformat
              ) {
                id
                slac
                datestatement
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.statements.length > 0) {
          let byteCharacters = atob(response.data.statements[0].documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, "statement_" + response.data.statements[0].id + ".pdf");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style>
</style>
